import React, { memo } from 'react';
import Image from '../../atom/image';
import HeadingH1 from '../../atom/heading/h1';
import Body from '../../atom/container/conatinerfull';
import './index.css';


const BannerTitle = (props) => {
    return (
        <Body class="padd0">
            <div className="relative">
                <Image image={props.image} class={props.imgClass} />
                <div className="col-md-12 bannerHeading text-center">
                    <HeadingH1 title={props.title} class={props.class} />
                </div>

            </div>
        </Body>
    )
}
export default BannerTitle